import { FC } from 'react';
import { useSnapshot } from 'valtio';
import CollapsiblePanel from '../../elements/CollapsiblePanel/CollapsiblePanel';
import Summary from '../../elements/Summary/Summary';
import ApplicationsSideBar from '../components/ApplicationsSideBar/ApplicationsSideBar';
import ApplicationsStore from '../stores/applications-store';

import config from '../config/applications-config.json';
import { Box } from '@mui/material';
import FiltersHeader from '../../elements/FilterBox/FiltersHeader';
import { splitLongNames } from 'string-utils';
import {
  clearFilters,
  setSliderBuisnessPriority,
} from '../stores/applications-filters-store-actions';
import { toggleFiltersPanel } from '../stores/applications-store-actions';
import ApplicationsFiltersStore from '../stores/applications-filters-store';
import { AppPages } from '../../common/routing/app-navigator';
import { NavLink } from 'react-router-dom';
import InventoryFiltersStore from '../../dashboard-inventory/stores/inventory-filters-store';

const ApplicationsSidebarContainer: FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { total, filtersOpen, loading } = useSnapshot(ApplicationsStore);
  const {
    loadingFilters,
    filterBy,
    appsFiltersType,
    numberOfFilters,
    totalFilters,
    sliderBuisnessPriority,
    maxBuisnessPriority,
    searchValues,
    appsFiltersTypeSearch,
  } = useSnapshot(ApplicationsFiltersStore);
  const { inventoryAppsNotRelevant } = useSnapshot(InventoryFiltersStore);

  return (
    <CollapsiblePanel
      collapsedSize={config.sidebar.collapsedSize}
      in={filtersOpen}
      togglePanel={toggleFiltersPanel}>
      <ApplicationsSideBar
        disabled={loading.isPending() || loadingFilters.isPending()}
        filterList={filterBy}
        appsFiltersType={appsFiltersType}
        sliderBuisnessPriority={sliderBuisnessPriority}
        maxBuisnessPriority={maxBuisnessPriority}
        totalApplications={total}
        searchValues={searchValues}
        loadingFilters={loadingFilters}
        appsFiltersTypeSearch={appsFiltersTypeSearch}
        setSliderBuisnessPriority={setSliderBuisnessPriority}>
        <Summary
          headerText='Applications'
          total={total}
          count={totalFilters}
          onCollapse={toggleFiltersPanel}
          linkText={
            inventoryAppsNotRelevant && inventoryAppsNotRelevant !== 0
              ? `Show Irrelevant Apps (${inventoryAppsNotRelevant.toLocaleString()})`
              : 'Show Irrelevant Apps '
          }
          linkUrl={AppPages.IrrelevantApps}
          navComponent={NavLink}
        />
        <Box py={1}>
          <FiltersHeader
            numberOfFilters={numberOfFilters}
            filterIssuesBy={filterBy}
            onResetFilters={clearFilters}
            splitFilterTypeName={splitLongNames}
          />
        </Box>
      </ApplicationsSideBar>
    </CollapsiblePanel>
  );
};

export default ApplicationsSidebarContainer;
